import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { FetchCampaignSlot } from '../api/fetch-campaign-slot';

export function useCampaignSlot() {
  const queryKeys = useQueryKeys();
  const { workspaceId } = useWorkspaceId();

  return useQuery({
    queryKey: queryKeys.campaign.slot(),
    queryFn: ({ signal }) => FetchCampaignSlot(workspaceId, signal),
    staleTime: 0,
  });
}
